export function useCreateSubstringText(text, subStr) {

    if(text && text.length > subStr) return text.substring(0, subStr) +'....';

    return text;
}
